import useSWRV from "@/store/swrv";
import { computed } from "@vue/composition-api";
import axios from "axios";

export default function () {
  const { data, error, isLoaded, reload } = useSWRV(
    "/api/app/billing/payment-method"
  );
  const isSaved = computed(() => {
    return data.value && data.value.gateway;
  });
  const savedCard = computed(() => {
    return (
      data.value &&
      data.value.gateway == "stripe" &&
      data.value.payment_method &&
      data.value.payment_method.card
    );
  });

  return {
    isSaved,
    isLoaded,
    error,
    savedCard,
    delete() {
      axios.delete("/api/app/billing/payment-method").then(reload);
    },
  };
}
